// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1hrEx","col":"CardReaderDesc_col__3-X6k","label":"CardReaderDesc_label__3io3P"};